












































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { handleResponse, errorMsg } from "@/utils/request";
@Component({
  name: "OrderLogging",
  components: {}
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = []; // lee 列表返回数据
  @Provide() private token: any; // 用户token
  @Provide() private userId: any; // 用户userId
  @Provide() private pageIndex: number = 1; // 分页数据
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  private created() {
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getExtenList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  // 获取列表数据
  private async getExtenList() {
    interface ITicketLogReq {
      ItemId: number;
      TicketId: number;
      token: string;
      userid: number;
    }
    let _arg: ITicketLogReq = {
      ItemId: Number(this.$route.query.itemId),
      TicketId: Number(this.$route.query.ticketId),
      token: this.token,
      userid: this.userId
    };
    const { getTicketLog }: any = await import("@/request/getTicketLog");
    let res = await getTicketLog(_arg);
    if (res && res.listList) {
      this.resultData = res.listList;
      this.pagerCount = res.pageout.total;
    }
  }
}
